module.exports = __webpack_public_path__ + "img/questionnaire_banner.22f56e8c.jpg";